import FlowScreens from 'core/common/components/FlowScreens';
import { LoadingStatuses } from 'core/common/entities';
import { useRouter } from 'core/common/hooks';
import { FlowScreens as RedesignFlowScreens } from 'core/common/ui/pages';
import { funnelFeatureDefaultValue } from 'core/feature-flags/config/funnelFeature';
import { FeaturesPayload } from 'core/feature-flags/entities';
import { useFeatureFlags } from 'core/feature-flags/hooks';
import { resolveFlowId } from 'core/feature-flags/utils';
import { FlowProvider, FunnelProviderDeprecated } from 'core/funnel/contexts';
import { FunnelConfig } from 'core/funnel/entities';
import { useFunnelConfigDeprecated } from 'core/funnel/hooks';
import { getIsRedesign } from 'core/funnel/utils';

type FunnelProps = {
  pageId: string;
  funnelId: string;
  funnelConfig: FunnelConfig | null;
  featuresPayload: FeaturesPayload | null;
};

const Funnel = ({ pageId, funnelId, funnelConfig, featuresPayload }: FunnelProps) => {
  const { locale = 'en' } = useRouter();
  const featureFlags = useFeatureFlags();

  const { config, loadingStatus, featureFlagsConfig, featureFlagsLoadingStatus } =
    useFunnelConfigDeprecated({
      funnelConfig,
      featuresPayload,
      funnelId,
    });

  const funnelConfigIsReady = loadingStatus !== LoadingStatuses.PENDING && config;
  const featuresConfigIsReady =
    featureFlagsLoadingStatus !== LoadingStatuses.PENDING && featureFlagsConfig;

  if (!funnelConfigIsReady || !featuresConfigIsReady) {
    return null;
  }

  const funnel = featureFlags.getFeatureValue(funnelId, funnelFeatureDefaultValue);
  const flowId = resolveFlowId(funnel, locale);

  const isRedesignFlow = getIsRedesign(flowId);

  return (
    <FunnelProviderDeprecated resources={config}>
      <FlowProvider>
        {isRedesignFlow ? (
          <RedesignFlowScreens screenId={pageId} />
        ) : (
          <FlowScreens pageId={pageId} />
        )}
      </FlowProvider>
    </FunnelProviderDeprecated>
  );
};

export default Funnel;
